export class FormularioSustento {
  IdFormulario: number;
  Comentario: string;
  constructor(IdForm: number) {
    this.IdFormulario = IdForm;
  }
}
